<template>
  <base-modal name="success">
    <template #body>
      <div class="mt-50 text-center">
        <div class="my-50">
          <img :src="checkIcon" alt="check" class="inline" />
        </div>
        <div class="my-50">
          <h6 class="font-semibold text-18 text-title">
            <span class="block text-success">{{ title }}</span>
            <span class="block">{{ subtitle }}</span>
          </h6>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script>
import checkSuccess from '@/assets/icons/svg/CheckCircle_Successful.svg';
import BaseModal from './BaseModal.vue';

export default {
  name: 'SuccessModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      checkIcon: checkSuccess,
    };
  },
};
</script>

<style></style>
